module.exports = " <div> <div v-for=\"(filter, i) in offerGroups\" :key=\"`filter-group-${i}`\" class=\"filter__item brands\"> <span class=filter__title data-for=marcas>{{ filter.title }}</span> <div class=filter__content data-name=marcas data-type=checkboxes> <div class=filter--checkbox> <input type=checkbox name=motorola id=motorola /> <label for=motorola class=\"\">item</label> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/offers/offers-filter.vue
// module id = 398
// module chunks = 0